module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "header-container box-shadow"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.calname))])]), _vm._v(" "), _c('div', {
    staticClass: "nav-right no-print"
  }, [_c('set-locale', {
    on: {
      "locale": _vm.emitLocale
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "print-button marg-5-left",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]), _vm._v(" "), _c('button', {
    staticClass: "print-button marg-5-left",
    on: {
      "click": _vm.printWithoutColors
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  }), _vm._v(" " + _vm._s(_vm.$t('calendars.public.print_in_black_white')) + "\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docendo-logo box-shadow no-print"
  }, [_c('span', {
    staticClass: "icon-docendo docendo-logo__icon",
    attrs: {
      "id": "d-icon"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f169b42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Desktop/Header.vue
// module id = 1599
// module chunks = 1